<template>
  <div class="progress-nav">
    <div
      class="step"
      v-for="(item, index) in Array.from(Array(3).keys())"
      :key="index + '-pb-step'"
    >
      <div class="step-background" :class="{ show: index + 1 <= stepsCompleted }"></div>
    </div>
  </div>
</template>

<script>
export default { name: "ProjectProgressBar", props: ["stepsCompleted"] };
</script>

<style lang="scss" scoped>
.progress-nav {
  background: transparent;
  display: flex;
  height: 5px;
  margin-top: auto;
  justify-content: space-between;
  margin-top: 1px;
  width: calc(100%);
  .step {
    border-radius: 6px;
    width: 33%;
    background: transparent;
    height: 100%;

    .step-background {
      height: 100%;
      width: 100%;
      border-radius: 6px;
      background: $grey-light;
      transition: all .5s ease;
      &.show {
        background: transparent;
        width: 100%;

        @keyframes hide {
          from {
            clip-path: inset(0 100% 0 0);
          }
          to {
            clip-path: inset(0 0 0 0);
          }
        }
      }
    }

    &:nth-child(1) {
      background: linear-gradient(to right, #c8182b, #662a94);
    }
    &:nth-child(2) {
      background: linear-gradient(to right, #0750ed, #0573b3);
    }
    &:nth-child(3) {
      background: linear-gradient(to right, #059254, #059c37);
    }
  }
}
</style>
